import { getRegistrationEmailValidationError } from "./registrationEmailValidation";

export function validateCorporateContactForm(contactForm) {
  const errors = {};
  if (!contactForm.full_name?.trim()) {
    errors.full_name = "Required";
  }

  const emailError = getRegistrationEmailValidationError(contactForm.email, {
    requiredMessage: "Required",
  });
  if (emailError) {
    errors.email =
      emailError === "Please enter a valid email address" ? "Invalid email" : emailError;
  }

  return errors;
}
